












import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";

@Component
export default class WtPaytype extends Vue {
  @Prop({ default: "", type: [String, Number] }) value;
  @Prop({ default: "", type: [String] }) type; // TODO: 纯文本，图片在左，图片在右
  // @Prop({ default: () => ({}), type: [Object] }) props; // optionMap的key和这个映射，如：{ '21': '2' },表示21为微信
  @Prop({ default: "", type: [String] }) placeholder; // 空的时候占位符

  private aliasPath = "./assets/image";

  get optionMap() {
    const { placeholder } = this;
    return {
      "": {
        icon: "",
        label: placeholder || ""
      },
      5: {
        icon: "wt-order-bonus.png",
        label: "奖励金",
        tag: "bonus,奖励金,walletpay" // 识别该label的匹配字符
      },
      1: {
        icon: "",
        label: "线下支付",
        tag: "offline,线下支付"
      },
      2: {
        icon: "wt-order-wx.png",
        label: "微信",
        tag: "wx,weixin,微信,weixinapplet"
      },
      3: {
        icon: "wt-order-alipay.png",
        label: "支付宝",
        tag: "alipay,alipaynative,支付宝"
      },
      4: {
        icon: "wt-order-unionpay.png",
        label: "云闪付",
        tag: "unionPay,unionpayApp,云闪付"
      },
      6: {
        icon: "credit.png",
        label: "信用金",
        tag: "credit"
      }
    };
  }

  get valueObj() {
    const { value = "", optionMap } = this;
    const matchedStrValue = el => {
      for (let key in optionMap) {
        const value =
          el && optionMap[key].tag && !!~optionMap[key].tag.indexOf(el)
            ? key
            : "";
        if (value) return value;
      }
    };
    return (
      optionMap[matchedStrValue(value)] ||
      (value && { label: value }) ||
      optionMap[""]
    );
  }
  // fOptionMap () {
  // 	const { props } = this;
  // 	return this.optionMap;
  // }
}
